import { FC } from 'react'

import styled from 'styled-components'

import { SelectButton } from 'src/Components/Buttons/SelectButton'

import { MAX_TABLET_WIDTH } from '../../../Styled/variables'

import { BadgesBlock } from './BadgesBlock'
import { CuratorInfo } from './CuratorInfo'
import { PriceInfo } from './PriceInfo'

interface CuratorInfoItemProps {
  curatorName: string
  playlistCount: number
  price: string
  selected: boolean
  avatarUrl?: string | null
  onSelect?: () => void
  matchingPercent?: number
  madePlacements?: boolean
  isSaved?: boolean
  lastActivity?: string | Date
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 320px;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    flex-direction: column;
    align-items: stretch;
    min-width: unset;
    width: 100%;
  }
`

const RightBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  margin-left: auto;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin-left: 0;
  }
`

const PriceWrapper = styled.div`
  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    padding-left: 70px;
  }
`

export const CuratorInfoItem: FC<CuratorInfoItemProps> = ({
  curatorName,
  playlistCount,
  price,
  selected,
  avatarUrl,
  onSelect,
  matchingPercent,
  madePlacements,
  isSaved,
  lastActivity,
}) => (
  <Container>
    <CuratorInfo
      avatarUrl={avatarUrl || void 0}
      curatorName={curatorName}
      playlistCount={playlistCount}
    />
    <ActionsContainer>
      <BadgesBlock
        matchingPercent={matchingPercent}
        madePlacements={madePlacements}
        isSaved={isSaved}
        lastActivity={lastActivity}
      />
      <RightBlock>
        <PriceWrapper>
          <PriceInfo price={price} />
        </PriceWrapper>
        <SelectButton selected={selected} onClick={onSelect} />
      </RightBlock>
    </ActionsContainer>
  </Container>
)
